import React, { useEffect } from "react";
import WinReportByMix from "./panelGroups/WinReportByMix";
import WinLoseReport from "./panelGroups/WinLoseReport";
import BettingReportByUser from "./panelGroups/BettingReportByUser";
import WinLoseReportByDate from "./panelGroups/WinLoseReportByDate";
import WinLoseReportCompare from "./panelGroups/WinLoseReportCompare";
import MostWinningUserList from "./panelGroups/MostWinningUserList";
import BettingReportByMix from "./panelGroups/BettingReportByMix";
import { connectSocket } from "../../utils/socket";

function Dashboard() {  
  useEffect(() => {
    const userDetails = sessionStorage.getItem("userDetails");
    if (!userDetails) {
      window.location.href = "/login";
    }

    const socket = connectSocket();

     function onConnect() {
      console.log("Connected to backend",socket.connected);
    }

    function onDisconnect() {
      console.log("Disconnected from backend",socket.connected);
    }

    // function onCronUpdate(payload) {
    //   console.log("Received cron:update", payload);
    //   setStatus(payload);
    // }

    socket.on("connect", onConnect);
    socket.on("disconnect", onDisconnect);
    //socket.on("cron:update", onCronUpdate);

    return () => {
      socket.off("connect", onConnect);
      socket.off("disconnect", onDisconnect);
      //socket.off("cron:update", onCronUpdate);
    };

  }, [])

  return (
    <div>
      <header className="shadow">
        <div className="mx-auto max-w-7xl px-4 py-3 sm:px-6 lg:px-8 bg-white dark:bg-custom_dark_background">
          <h1 className="text-1xl font-bold tracking-tight text-gray-900 dark:text-customWhite">
            Dashboard
          </h1>
        </div>
      </header>
      <main>
        <div className="mx-auto max-w-full py-3 sm:px-3 lg:px-5">
          <div className="flex justify-center w-[100%] gap-5">
            <div className="w-[25%] rounded-md border border-gray-200 drop-shadow-md" style={{ height: "320px", background: '#ecf0f3' }}>
              <WinReportByMix />
            </div>
            <div className="w-[25%] rounded-md border border-gray-200 drop-shadow-md" style={{ height: "320px", background: '#ecf0f3' }}>
            <WinLoseReport />
            </div>
            <div className="w-[50%] rounded-md border border-gray-200 drop-shadow-md" style={{ height: "320px", background: '#ecf0f3' }}>
            <BettingReportByUser />
            </div>
          </div>
          <div className="flex justify-center w-[100%] gap-5 mt-3">
            <div className="w-[70%] rounded-md border border-gray-200 drop-shadow-md" style={{ height: "320px", background: '#ecf0f3' }}>
              <WinLoseReportByDate />
            </div>
            <div className="w-[30%] rounded-md border border-gray-200 drop-shadow-md" style={{ height: "320px", background: '#ecf0f3' }}>
            <MostWinningUserList />
            </div>
          </div>
          <div className="flex justify-center w-[100%] gap-5 mt-3">
          <div className="w-[30%] rounded-md border border-gray-200 drop-shadow-md" style={{ height: "320px", background: '#ecf0f3' }}>
          <BettingReportByMix />
            </div>
            <div className="w-[70%] rounded-md border border-gray-200 drop-shadow-md" style={{ height: "320px", background: '#ecf0f3' }}>
            <WinLoseReportCompare />  
            </div>
          </div>
        </div>
      </main>
    </div> 
  );
}

export default Dashboard;
